import * as React from "react";
function ExpandLeftIcon(props) {
    return React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", height: "1em", width: "1em", ...props },
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16.619 2.381a.875.875 0 0 1 0 1.238l-8.382 8.377 8.382 8.385a.875.875 0 0 1-1.238 1.238l-9-9.005a.875.875 0 0 1 0-1.237l9-8.996a.875.875 0 0 1 1.238 0", clipRule: "evenodd" }));
}
export default ExpandLeftIcon;
//# sourceMappingURL=ExpandLeft.js.map